import { render, staticRenderFns } from "./ShelfByArgs.vue?vue&type=template&id=733a7cd7&scoped=true"
import script from "./ShelfByArgs.vue?vue&type=script&lang=js"
export * from "./ShelfByArgs.vue?vue&type=script&lang=js"
import style0 from "./ShelfByArgs.vue?vue&type=style&index=0&id=733a7cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a7cd7",
  null
  
)

export default component.exports